// Types
import type { ItemType } from "pages/Accounts/Transaction/OpeningBalance/utils"

export function getHistoryBalance(list: ItemType[]) {
  return {
    item: list.find(item => item.linked_code === "LA03"),
    index: list.findIndex(item => item.linked_code === "LA03")
  }
}